import { render, staticRenderFns } from "./EmailTemplateMY.vue?vue&type=template&id=6d6b3c76&scoped=true&"
import script from "./EmailTemplateMY.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateMY.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplateMY.vue?vue&type=style&index=0&id=6d6b3c76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6b3c76",
  null
  
)

export default component.exports